/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingupdatedwithimages3Inputs */

const en_listingupdatedwithimages3 = /** @type {(inputs: Listingupdatedwithimages3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing updated with images!`)
};

const de_listingupdatedwithimages3 = /** @type {(inputs: Listingupdatedwithimages3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort mit Bildern aktualisiert!`)
};

/**
* | output |
* | --- |
* | "Listing updated with images!" |
*
* @param {Listingupdatedwithimages3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingupdatedwithimages3 = /** @type {((inputs?: Listingupdatedwithimages3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingupdatedwithimages3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingupdatedwithimages3(inputs)
	return de_listingupdatedwithimages3(inputs)
});
export { listingupdatedwithimages3 as "listingUpdatedWithImages" }